
(function () {
  'use strict';

  

  
  var WC_SHIRT_BASE_CENTS   = 3300;
  var WC_STICKER_BASE_CENTS = 399;

  

  
  if (window.WCTier && window.WCTier.__inited) return;

  var TIERS = [
    { qty: 1, off: 0,  per: 33.00, label: 'add 1 shirt'   },
    { qty: 2, off: 10, per: 29.70, label: 'mix 2 shirts'  },
    { qty: 3, off: 20, per: 26.40, label: 'mix 3 shirts'  },
    { qty: 4, off: 30, per: 23.10, label: 'mix 4 shirts'  },
    { qty: 5, off: 40, per: 19.80, label: 'mix 5 shirts'  },
    { qty: 6, off: 50, per: 16.50, label: 'mix 6+ shirts', top: true }
  ];

  var EVENT_NAME = 'wc:tier-updated';
  var lastState = null;

  function tierForCount(count) {
    if (count >= 6) return TIERS[5];
    if (count <= 0) return null;
    return TIERS[count - 1];
  }
  function nextTierForCount(count) {
    if (count >= 6) return null;
    if (count < 1) return TIERS[1]; 
    return TIERS[count]; 
  }
  function isFreeGift(item) {

    

    

    

    

    
    return (item.sku || '') === 'WC-FreeMystery10pack-stickers';
  }

  function recompute() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = 0;

        
        
        var paidSubtotalCents = 0;
        var nonGiftItems = [];

        

        
        var shirtCount = 0;
        var stickerCount = 0;
        var hasOther = false;
        (cart.items || []).forEach(function (item) {
          if (isFreeGift(item)) return;
          count += item.quantity;
          var unitPrice = (typeof item.original_price === 'number')
            ? item.original_price
            : (item.price || 0);
          var lineRetail = (typeof item.original_line_price === 'number')
            ? item.original_line_price
            : unitPrice * item.quantity;
          paidSubtotalCents += lineRetail;
          nonGiftItems.push({ unit: unitPrice, qty: item.quantity });
          if (unitPrice === WC_SHIRT_BASE_CENTS)        shirtCount   += item.quantity;
          else if (unitPrice === WC_STICKER_BASE_CENTS) stickerCount += item.quantity;
          else                                          hasOther = true;
        });
        var tier = tierForCount(count);
        var next = nextTierForCount(count);
        var pct  = Math.min(100, (count / 6) * 100);
        var tierOff = tier ? tier.off : 0;

        

        
        var bmsmSavingsCents = 0;
        if (tierOff > 0) {
          for (var i = 0; i < nonGiftItems.length; i++) {
            var unitSavings = Math.floor(nonGiftItems[i].unit * tierOff / 100);
            bmsmSavingsCents += unitSavings * nonGiftItems[i].qty;
          }
        }

        var state = {
          count: count,
          off: tierOff,
          per: tier ? tier.per : 33.00,
          tierIndex: tier ? TIERS.indexOf(tier) : -1,
          atTop: count >= 6,
          nextOff: next ? next.off : null,
          nextQty: next ? next.qty : null,
          nextPer: next ? next.per : null,
          pct: pct,
          cartTotal: cart.total_price || 0,
          paidSubtotalCents: paidSubtotalCents,
          bmsmSavingsCents: bmsmSavingsCents,
          shirtCount: shirtCount,
          stickerCount: stickerCount,
          hasOther: hasOther
        };
        lastState = state;

        document.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: state }));
        return state;
      })
      .catch(function (err) {
        console.error('[wc-tier-controller] cart fetch error:', err);
      });
  }

  window.WCTier = {
    TIERS: TIERS,
    EVENT_NAME: EVENT_NAME,
    getState: function () { return lastState; },
    recompute: recompute,
    tierForCount: tierForCount,
    nextTierForCount: nextTierForCount,
    __inited: true
  };

  function init() {
    
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { recompute(); });
    }
    
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') recompute();
    });

    

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) recompute();
    });
    recompute();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();